// convert miles to nearest whole kilometer
export const milesToKMRnd = miles => miles * 1609
export const meterToMiles = meters => meters / 1609
